{
  "title": "Catnap",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level Enchantment",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "S, M (a pinch of sand)",
  "duration": "10 minutes",
  "description": [
    "You make a calming gesture, and up to three willing creatures of your choice that you can see within range fall unconscious for the spell’s duration. The spell ends on a target early if it takes damage or someone uses an action to shake or slap it awake. If a target remains unconscious for the full duration, that target gains the benefit of a short rest, and it can’t be affected by this spell again until it finishes a long rest."
  ],
  "spellLists": ["artificer", "bard", "arcane-trickster", "sorcerer", "wizard"]
}
